import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsReportsTemplateRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-reports',
	path: '/jira/servicedesk/assets/reports/:templateId',
	exact: true,
};
